import React from 'react';
import logo from '../../../assets/logo_farmRio_white.svg';

export default function MobileBanner() {
  return (
    <div
      style={{
        background:
          'url("https://storage.googleapis.com/showroom-bucket-images/SS26/Home/Who_We_Are.jpg") no-repeat center top / cover',
        minHeight: '100vh',
        width: '100vw',
        color: 'white',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.55)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '32px 24px',
          boxSizing: 'border-box',
        }}
      >
        <img
          src={logo}
          alt="FARM Rio"
          style={{ height: 56, marginBottom: 32 }}
        />
        <h2
          style={{
            fontSize: 22,
            fontWeight: 400,
            letterSpacing: '0.05em',
            margin: 0,
            marginBottom: 16,
          }}
        >
          Desktop only experience
        </h2>
        <p
          style={{
            fontSize: 15,
            lineHeight: 1.6,
            maxWidth: 320,
            margin: 0,
            letterSpacing: '0.02em',
          }}
        >
          FARM RIO&apos;s Digital Showroom is available on desktop only.
          <br />
          <br />
          For full access, please use a computer or laptop. For any questions,
          reach out to{' '}
          <a
            href="mailto:wholesale@farmrio.com"
            style={{ color: 'white', textDecoration: 'underline' }}
          >
            wholesale@farmrio.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
